import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewNo = () => {
    return <AnonymousView languageCode="no" />
}

export default AnonymousViewNo
